import { readText, writeText } from 'clipboard-polyfill';

export default {
  writeText,
  readText,
};
